module.exports = __webpack_public_path__ + "static/img/1348_phase_function_Paper_PointsHejduk_Prediction.e08137f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/1348_phase_function_Paper_PointsHejduk_Prediction.png
// module id = o0Ph
// module chunks = 0